<template>
    <div class="background" >
        
      <div style="height:40px"></div>
      <div class="font-xll">
          <p>Request to remove user data from yoyo</p>
          <div style="height:20px"></div>
      </div>
      <div style="height:30px"></div>
      <div class="container-center">
          <div class="input-container">
              <h1>Confirm account</h1>
              <form @submit.prevent="confirmSubmit">
                <div style="margin-right: 15px;margin-top: 20px;">
                  <label style="float:inline-start" for="username">User Account:</label>
                  <input  type="text" id="username" v-model="dataForm.username" required>
                </div>
                <div style="margin-right: 15px;">
                  <label  style="float:inline-start" for="password">Password:</label>
                  <input type="password" id="password" v-model="dataForm.password" required>
                </div>
                <button type="submit">Confirm for Removing Data</button>
              </form>
            </div>
            
            <div class="tips">
              <p>*Yoyo will remove the data within 7 to 15 working days after your successful submission.</p>
            </div>
      </div>
   
    </div>
</template>

<script>
import axios from 'axios'
import { requestService } from '@/api/apiService'

export default {
  data() {
    return {
      getEmailTokenBtnText: 'Get token',
      isDisabled: true,
      confirmRequesting: false,
      dataForm: {
          username: '',
          password: ''
      }
    };
  },
  methods: {
    async confirmSubmit() {
      if (this.confirmRequesting) {
        return
      }
      var data = {
              "userAccount": this.dataForm.username,
              "password": this.dataForm.password
          }
      var params = {
          "data": data,
          "method": "clearUserData"
          }
      this.confirmRequesting = true
      try {
        const result = await requestService('/services/account', 'POST', params);
        alert(result.message)
      } catch (error) {
        alert(error.message)
      }
      this.confirmRequesting = false
    },
  },
  
};
</script>

<style scoped>

.input-container {
    width: 300px;
    margin: 20px auto;
    padding: 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  }
  form div {
    margin-bottom: 15px;
  }
  label {
    display: block;
    margin-bottom: 5px;
  }
  input[type="text"], input[type="password"] {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 5px;
    font-size: 16px;
  }
  button[type="submit"] {
    width: 100%;
    padding: 10px;
    border: none;
    border-radius: 5px;
    background-color: #5cb85c;
    color: white;
    cursor: pointer;
  }
  button[type="submit"]:hover {
    background-color: #4cae4c;
  }

.background {
    position: fixed;
    width: 100%;
    height: 100%;
    background-image: url('../assets/weee.jpg');
    opacity: 0.8;
    background-size: cover;
    background-position: center;
    flex: 1;
}
.font-xll {
    font-family: 微软雅黑;
    font-size: 22px;
    color:#faf6f6;
}
.dl-container {
    margin: 0 auto;
    font-family: 微软雅黑;
    font-size: 15px;
    /*float: left;*/
    div {
        /*float: inline-start;*/
        display: block;
    }
}


.container-center {
    background: #faf6f6;
    padding-top: 1px;
    margin: 0 auto;
    font-family: 微软雅黑;
    font-size: 15px;
    width: 400px;
    height: 420px;
    display: block;

}

.dl-container-center {
    margin: 0 auto;
    font-family: 微软雅黑;
    font-size: 15px;
    width: 200px;
    height: 200px;
    display: block;

}

.dl-htn {
    /*display: inline; */
    /*position:relative;*/
    align-items: center; 
    justify-content: center;
    display: flex;
    color: #faf6f6;
    padding-left: 10px;
    padding-right: 10px;
    background-color: #07b97e9c;
    height: 40px;
    border-radius: 20px;
    border:solid 1px white;
   .p {
        margin-top: 10px;
   }
}
.dl-htn:hover {
    background-color: #07b97e9c;
    box-shadow: 1px 1px 1px 1px  #07b97e54;
    border:solid 1px rgba(224, 13, 13, 0.596);
    color: #0a07d3;

}
.dl-htn-ps {
    margin-top: 8px;
    font-size: 12px;
    color: #faf6f6;
}

.text-button {
  float:inline-end;
  background-color: transparent;
  border: none;
  padding: 0;
  margin: 0;
  font-size: 16px;
  cursor: pointer;
  color: #0056b3; /* 文本颜色 */
  text-decoration: underline;
  /* 其他样式根据需要调整 */
}
   
.text-button:hover {
  text-decoration: none; /* 鼠标悬停时去下划线 */
  color: #00346e; /* 鼠标悬停时的颜色 */
}

.tips {
  text-align: left;
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 8px;
  font-size: 10px;
  color: #4f4e4e;
}

</style>
